/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ task: NonNullable<unknown> }} Automation_Trigger_Task_DoneInputs */

const en_automation_trigger_task_done = /** @type {(inputs: Automation_Trigger_Task_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.task} completed`)
};

const pt_br2_automation_trigger_task_done = /** @type {(inputs: Automation_Trigger_Task_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.task} concluída`)
};

/**
* | output |
* | --- |
* | "{task} completed" |
*
* @param {Automation_Trigger_Task_DoneInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_trigger_task_done = /** @type {((inputs: Automation_Trigger_Task_DoneInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Trigger_Task_DoneInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_trigger_task_done(inputs)
	return pt_br2_automation_trigger_task_done(inputs)
});